<!-- TABLEAU -->
<p-table [value]="donnee">
  <ng-template pTemplate="header">
    <tr>
      <th>Utilisateur</th>
      <th>Status</th>
      <th>Taches en cours</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-c>
    <tr>
      <td>{{c.user_name}}</td>
      <td><span *ngIf="c.status == 'En ligne'" style="background-color:#FFD8B2;">{{c.status}}</span><span *ngIf="c.status == 'Hors-ligne'" style="background-color:#B3E5FC;">{{c.status}}</span></td>
      <td>{{c.taches}}</td>
    </tr>
  </ng-template>
</p-table>
